import { SortDirection } from '@angular/material/sort';

import { BaseListFilter } from '../../../models/base-list-filter.model';

export class CommissionIssuersFilter extends BaseListFilter {
  search?: string;
  isVerified?: boolean;
  brokerId?: number;

  constructor(
    public sortBy: string = 'id',
    public sortDirection: SortDirection = 'desc',
  ) {
    super();
  }
}
